const GmailIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 26.3112C0 17.1013 0 12.4965 1.79233 8.97882C3.36893 5.88461 5.88461 3.36893 8.97882 1.79233C12.4965 0 17.1013 0 26.3112 0H47.6888C56.8986 0 61.5035 0 65.0212 1.79233C68.1154 3.36893 70.6311 5.88461 72.2076 8.97882C74 12.4965 74 17.1013 74 26.3112V47.6888C74 56.8986 74 61.5035 72.2076 65.0212C70.6311 68.1154 68.1154 70.6311 65.0212 72.2076C61.5035 74 56.8986 74 47.6888 74H26.3112C17.1013 74 12.4965 74 8.97882 72.2076C5.88461 70.6311 3.36893 68.1154 1.79233 65.0212C0 61.5035 0 56.8986 0 47.6888V26.3112Z"
      fill="white"
    />
    <path
      d="M52.9933 17.2392L37.1702 29.5878L20.9854 17.2392V17.2425L21.005 17.2592V34.5506L36.9879 47.166L52.9933 35.0377V17.2392Z"
      fill="#EA4335"
    />
    <path
      d="M57.1467 14.2355L52.9913 17.2391V35.0377L66.0669 24.9988V18.9512C66.0669 18.9512 64.4798 10.314 57.1467 14.2355Z"
      fill="#FBBC05"
    />
    <path
      d="M52.9913 35.0377V58.1228H63.013C63.013 58.1228 65.865 57.8292 66.07 54.5784V24.9988L52.9913 35.0377Z"
      fill="#34A853"
    />
    <path d="M21.0057 58.1431V34.5506L20.9854 34.5339L21.0057 58.1431Z" fill="#C5221F" />
    <path
      d="M20.9847 17.2421L16.8521 14.2551C9.51904 10.3336 7.92859 18.9676 7.92859 18.9676V25.0149L20.9847 34.5334V17.2421Z"
      fill="#C5221F"
    />
    <path d="M20.9854 17.2431V34.5345L21.0057 34.5511V17.2598L20.9854 17.2431Z" fill="#C5221F" />
    <path
      d="M7.92859 25.0194V54.599C8.13067 57.8532 10.9857 58.1436 10.9857 58.1436H21.0075L20.9847 34.5345L7.92859 25.0194Z"
      fill="#4285F4"
    />
  </svg>
);
export default GmailIcon;
